import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/app/_sidebar-layout/seo-strategy/$brandId/')({
  beforeLoad: function ({ params: { brandId } }) {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/app/seo-strategy/$brandId/overview',
      params: { brandId },
      replace: true,
    });
  },
  component: function () {
    return null;
  },
});
